/**
 * The columns of the Resources view on the facility calendar.
 *
 * One column stands for one bay. A bay is a facility resource of kind
 * `bookable`. A location takes no booking, so it gets no column.
 */
import { bayColumnId } from "app/models/EventModel";
import {
  ScheduleResourceResponse,
  activeBaysInAdminOrder,
} from "app/utils/request/scheduling/facilityResources";

// A bay keeps no hours of its own in this stage. Without a range of its own,
// the column takes the calendar range, the hours of every coach together. The
// whole day shades nothing.
export const FULL_DAY_BUSINESS_HOURS = {
  daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
  startTime: "00:00",
  endTime: "24:00",
};

export interface BayColumn {
  id: string;
  title: string;
  order: number;
  businessHours: typeof FULL_DAY_BUSINESS_HOURS;
  extendedProps: { section: string };
}

/**
 * Builds one column per active bay.
 *
 * Orders the columns as the Resources page does: the sections in admin order,
 * then the bays of each section in admin order. An inactive bay gets no
 * column, because no one books it any more.
 */
export function buildBayColumns(
  resources: ScheduleResourceResponse[],
): BayColumn[] {
  return activeBaysInAdminOrder(resources).map((resource, index) => ({
    id: bayColumnId(resource.id),
    title: resource.title,
    order: index,
    businessHours: FULL_DAY_BUSINESS_HOURS,
    extendedProps: { section: resource.resourceCategory.title },
  }));
}
